import styled from '../styled-components';

export const PageContainer = styled.div`
  min-height: 100%;
  box-sizing: border-box;
  width: 100%;
`;
